module.exports = [
  0x0023,
  0x002a,
  0x0030,
  0x0031,
  0x0032,
  0x0033,
  0x0034,
  0x0035,
  0x0036,
  0x0037,
  0x0038,
  0x0039,
  0x00a9,
  0x00ae,
  0x203c,
  0x2049,
  0x2122,
  0x2139,
  0x2194,
  0x2195,
  0x2196,
  0x2197,
  0x2198,
  0x2199,
  0x21a9, // ..
  0x21aa,
  0x231a, // ..
  0x231b,
  0x2328,
  0x23cf,
  0x23e9, // ..
  0x23f3,
  0x23f8, // ..
  0x23fa,
  0x24c2,
  0x25aa, // ..
  0x25ab,
  0x25b6,
  0x25c0,
  0x25fb, // ..
  0x25fe,
  0x2600, // ..
  0x2604,
  0x260e,
  0x2611,
  0x2614,
  0x2615,
  0x2618,
  0x261d,
  0x2620,
  0x2622,
  0x2623,
  0x2626,
  0x262a,
  0x262e,
  0x262f,
  0x2638, // ..
  0x263a,
  0x2640,
  0x2642,
  0x2648, // ..
  0x2653,
  0x265f,
  0x2660,
  0x2663,
  0x2665,
  0x2666,
  0x2668,
  0x267b,
  0x267e,
  0x267f,
  0x2692, // ..
  0x2694,
  0x2695,
  0x2696,
  0x2697,
  0x2699,
  0x269b, // ..
  0x269c,
  0x26a0, // ..
  0x26a1,
  0x26aa, // ..
  0x26ab,
  0x26b0, // ..
  0x26b1,
  0x26bd, // ..
  0x26be,
  0x26c4, // ..
  0x26c5,
  0x26c8,
  0x26ce, // ..
  0x26cf,
  0x26d1,
  0x26d3, // ..
  0x26d4,
  0x26e9, // ..
  0x26ea,
  0x26f0, // ..
  0x26f5,
  0x26f7, // ..
  0x26fa,
  0x26fd,
  0x2702,
  0x2705,
  0x2708, // ..
  0x270d,
  0x270f,
  0x2712,
  0x2714,
  0x2716,
  0x271d,
  0x2721,
  0x2728,
  0x2733, // ..
  0x2734,
  0x2744,
  0x2747,
  0x274c,
  0x274e,
  0x2753, // ..
  0x2755,
  0x2757,
  0x2763, // ..
  0x2764,
  0x2795, // ..
  0x2797,
  0x27a1,
  0x27b0,
  0x27bf,
  0x2934, // ..
  0x2935,
  0x2b05, // ..
  0x2b07,
  0x2b1b, // ..
  0x2b1c,
  0x2b50,
  0x2b55,
  0x3030,
  0x303d,
  0x3297,
  0x3299,
  0x1f004,
  0x1f0cf,
  0x1f170, // ..
  0x1f171,
  0x1f17e, // ..
  0x1f17f,
  0x1f18e,
  0x1f191, // ..
  0x1f19a,
  0x1f1e6, // ..
  0x1f1ff,
  0x1f201, // ..
  0x1f202,
  0x1f21a,
  0x1f22f,
  0x1f232, // ..
  0x1f23a,
  0x1f250, // ..
  0x1f251,
  0x1f300, // ..
  0x1f321,
  0x1f324, // ..
  0x1f393,
  0x1f396, // ..
  0x1f397,
  0x1f399, // ..
  0x1f39b,
  0x1f39e, // ..
  0x1f3f0,
  0x1f3f3, // ..
  0x1f3f5,
  0x1f3f7, // ..
  0x1f4fd,
  0x1f4ff, // ..
  0x1f53d,
  0x1f549, // ..
  0x1f54e,
  0x1f550, // ..
  0x1f567,
  0x1f56f, // ..
  0x1f570,
  0x1f573, // ..
  0x1f579,
  0x1f57a,
  0x1f587,
  0x1f58a, // ..
  0x1f58d,
  0x1f590,
  0x1f595, // ..
  0x1f596,
  0x1f5a4,
  0x1f5a5,
  0x1f5a8,
  0x1f5b1, // ..
  0x1f5b2,
  0x1f5bc,
  0x1f5c2, // ..
  0x1f5c4,
  0x1f5d1, // ..
  0x1f5d3,
  0x1f5dc, // ..
  0x1f5de,
  0x1f5e1,
  0x1f5e3,
  0x1f5e8,
  0x1f5ef,
  0x1f5f3,
  0x1f5fa, // ..
  0x1f64f,
  0x1f680, // ..
  0x1f6c5,
  0x1f6cb, // ..
  0x1f6d0,
  0x1f6d1, // ..
  0x1f6d2,
  0x1f6d5,
  0x1f6e0, // ..
  0x1f6e5,
  0x1f6e9,
  0x1f6eb, // ..
  0x1f6ec,
  0x1f6f0,
  0x1f6f3,
  0x1f6f4, // ..
  0x1f6f6,
  0x1f6f7, // ..
  0x1f6f8,
  0x1f6f9,
  0x1f6fa,
  0x1f7e0, // ..
  0x1f7eb,
  0x1f90d, // ..
  0x1f90f,
  0x1f910, // ..
  0x1f911,
  0x1f912,
  0x1f913,
  0x1f914,
  0x1f915,
  0x1f916,
  0x1f917,
  0x1f918,
  0x1f919,
  0x1f91a,
  0x1f91b,
  0x1f91c,
  0x1f91d,
  0x1f91e,
  0x1f91f,
  0x1f920, // ..
  0x1f921,
  0x1f922,
  0x1f923,
  0x1f924,
  0x1f925,
  0x1f926,
  0x1f927,
  0x1f928, // ..
  0x1f929,
  0x1f92a,
  0x1f92b,
  0x1f92c,
  0x1f92d,
  0x1f92e,
  0x1f92f,
  0x1f930,
  0x1f931, // ..
  0x1f932,
  0x1f933, // ..
  0x1f93a,
  0x1f93c, // ..
  0x1f93e,
  0x1f93f,
  0x1f940, // ..
  0x1f945,
  0x1f947, // ..
  0x1f94b,
  0x1f94c,
  0x1f94d, // ..
  0x1f94f,
  0x1f950, // ..
  0x1f95e,
  0x1f95f, // ..
  0x1f96b,
  0x1f96c, // ..
  0x1f970,
  0x1f971,
  0x1f973, // ..
  0x1f974,
  0x1f975,
  0x1f976,
  0x1f97a,
  0x1f97b,
  0x1f97c, // ..
  0x1f97f,
  0x1f980, // ..
  0x1f984,
  0x1f985, // ..
  0x1f991,
  0x1f992, // ..
  0x1f997,
  0x1f998, // ..
  0x1f9a2,
  0x1f9a5, // ..
  0x1f9aa,
  0x1f9ae, // ..
  0x1f9af,
  0x1f9b0, // ..
  0x1f9b9,
  0x1f9ba, // ..
  0x1f9bf,
  0x1f9c0,
  0x1f9c1, // ..
  0x1f9c2,
  0x1f9c3, // ..
  0x1f9ca,
  0x1f9cd, // ..
  0x1f9cf,
  0x1f9d0, // ..
  0x1f9e6,
  0x1f9e7, // ..
  0x1f9ff,
  0x1fa70, // ..
  0x1fa73,
  0x1fa78, // ..
  0x1fa7a,
  0x1fa80, // ..
  0x1fa82,
  0x1fa90, // ..
  0x1fa95,
  0x10ffff,
  0x231a, // ..
  0x231b,
  0x23e9, // ..
  0x23ec,
  0x23f0,
  0x23f3,
  0x25fd, // ..
  0x25fe,
  0x2614, // ..
  0x2615,
  0x2648, // ..
  0x2653,
  0x267f,
  0x2693,
  0x26a1,
  0x26aa, // ..
  0x26ab,
  0x26bd, // ..
  0x26be,
  0x26c4, // ..
  0x26c5,
  0x26ce,
  0x26d4,
  0x26ea,
  0x26f2, // ..
  0x26f3,
  0x26f5,
  0x26fa,
  0x26fd,
  0x2705,
  0x270a, // ..
  0x270b,
  0x2728,
  0x274c,
  0x274e,
  0x2753, // ..
  0x2755,
  0x2757,
  0x2795, // ..
  0x2797,
  0x27b0,
  0x27bf,
  0x2b1b, // ..
  0x2b1c,
  0x2b50,
  0x2b55,
  0x1f004,
  0x1f0cf
];
